import React from 'react';
import { connect } from 'react-redux';
import { setPipMode } from '../../store/app';

const Pip = ({ pipMode, setPipMode }) => {
  window.enterPip = () => {
    if (!pipMode) {
      setPipMode(true);
    }
  };

  window.exitPip = () => {
    if (pipMode) {
      setPipMode(false);
    }
  };

  return <React.Fragment></React.Fragment>;
};

const mapStateToProps = (state) => {
  return {
    pipMode: state.app.pipMode,
  };
};

const mapDispatchToProps = {
  setPipMode,
};

export default connect(mapStateToProps, mapDispatchToProps)(Pip);
